import React, {Fragment, useMemo, useState} from "react";
import unescapeHtmlTag from "../../../../../core/utils/tools";
import {colorTargetReplacement} from "../../../../../core/utils/replace";
import {useSelector} from "react-redux";
import TabGroup from "../molecules/TabGroup";
import {COLOR_TARGETS} from "../../../../../core/constants/color";
import {renderPartStep, renderPersonalStep} from "./renderStepHelpers";
import ColorOptionDetail from "./ColorOptionDetail";
import PartOptionDetail from "./PartOptionDetail";

const DetailStepsView = ({stepObject, navigationDataObject, slideToMainHandler }) => {
  const [selectedColorTab, setSelectedColorTab] = useState(null);
  const langData = useSelector(state => state.theme.langData);

  const selectColorTabHandler = (tabIndex) => {
    setSelectedColorTab(stepObject?.stepItems?.[tabIndex]);
  };

  const targetColorItem = useMemo(() => {
    if (stepObject?.stepType === "COLOR") {
      const found = stepObject.stepItems.find(item =>
        item.colorTarget === COLOR_TARGETS.EXTERIOR_PRIMARY ||
        item.colorTarget === COLOR_TARGETS.INTERIOR_KEY
      );
      if (found) return found;
    }

    return null;
  }, [stepObject]);

  const renderColorStep = () => {
    const targetIndex = stepObject.stepItems.findIndex(
      item => item.colorTarget === navigationDataObject.colorTarget
    );

    return (
      <Fragment>
        {/* Tab Group */}
        {targetColorItem && stepObject.stepItems.length >= 1 && (
          <div className={"option-tab"}>
            <TabGroup
              defaultTabIndex={targetIndex}
              callback={selectColorTabHandler}
              firstTabName={stepObject.stepItems[0]?.nameEn}
              secondTabName={stepObject.stepItems[1]?.nameEn}
              thirdTabName={stepObject.stepItems[2]?.nameEn}
              executeInitialCallback={true}
              colorTarget={navigationDataObject.colorTarget}
            />
          </div>
        )}

        {/* Color Options */}
        {stepObject.stepItems.map((colorItemObject, colorItemObjectIdx) => {
          let code = colorTargetReplacement(colorItemObject.colorTarget);
          return (
            <Fragment key={'ColorStep_' + colorItemObjectIdx}>
              <ColorOptionDetail
                code={code}
                colorItemObject={colorItemObject}
                stepObject={stepObject}
                selectedColorTab={selectedColorTab}
                targetColorItem={targetColorItem}
              />
            </Fragment>
          );
        })}
      </Fragment>
    );
  };

  const renderHeader = () => {
    const backTargetDepth = navigationDataObject.backToDepth || "1";
    return (
      <div className={"option-subwrap-header"}>
        <button type={"button"} className={"slide-to-main"} onClick={() => slideToMainHandler(backTargetDepth)}>
          back to main
        </button>
        <h1>{unescapeHtmlTag(stepObject[langData.langName])}</h1>
      </div>
    );
  };

  return (
    <div className={"option-h2"}>
      {renderHeader()}

      {(() => {
        switch(stepObject.stepType) {
          case "COLOR":
            return renderColorStep();

          case "PART_3D":
          case "MATERIAL":
            return renderPartStep({
              PartComponent: PartOptionDetail,
              stepObject,
              langData,
              navigationDataObject,
            });

          case "PART_2D":
            return renderPersonalStep({
              PartComponent: PartOptionDetail,
              stepObject,
              langData,
              navigationDataObject,
            });
          default:
            return null;
        }
      })()}
    </div>
  );
}

export default DetailStepsView;
